import { Nav } from "./components/Nav";
import { Hero } from "./sections/Hero";
import { TrustStrip } from "./sections/TrustStrip";
import { ProblemSolution } from "./sections/ProblemSolution";
import { Features } from "./sections/Features";
import { Performance } from "./sections/Performance";
import { Compare } from "./sections/Compare";
import { Players } from "./sections/Players";
import { Pricing } from "./sections/Pricing";
import { CtaBand } from "./sections/CtaBand";
import { Footer } from "./sections/Footer";

export default function App() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <ProblemSolution />
        <Features />
        <Performance />
        <Compare />
        <Players />
        <Pricing />
        <CtaBand />
      </main>
      <Footer />
    </>
  );
}
